/** Requisites and terms extracted from the document texts. */
export const myloreLegal = {
  documentVersion: '20 сентября 2026 года',
  /**
   * Идентификатор редакции. Кликврап его сохраняет — запись должна говорить, с каким текстом
   * человек согласился, а не только когда.
   *
   * Поднят 20 сентября 2026 года: ветка добавляет в опубликованные документы запись об
   * уничтожении, срок карантина и адрес для жалоб — то есть текст изменился, а метка оставалась
   * на 8 сентября. У MyLore есть живые пользователи, поэтому расхождение метки с текстом здесь
   * важнее, чем на североамериканской стороне: именно метку называет запись о согласии.
   */
  documentVersionId: '2026-09-20',
  serviceName: 'Милор',
  siteUrl: 'https://mylore.ru',
  operator: {
    fullName: 'Индивидуальный предприниматель Ермолаев Константин Александрович',
    shortName: 'ИП Ермолаев Константин Александрович',
    inn: '162402098858',
    ogrnip: '324169000071001',
    taxSystem: 'УСН',
    email: 'support@mylore.ru',
    // YuKassa requires showing the phone number and postal address. The fields are kept in one
    // place so they can be published without editing the document texts.
    phone: '+7 962 551-97-53',
    phoneHref: 'tel:+79625519753',
    postalAddress:
      '422616, Республика Татарстан, Лаишевский район, село Усады, улица Комиссариатская, дом 70А',
  },
  /** The brand's own accounts: the handle is what the footer shows. */
  socials: {
    telegram: { handle: '@mylorebooks', href: 'https://t.me/mylorebooks' },
    instagram: { handle: '@mylore_books', href: 'https://www.instagram.com/mylore_books' },
  },
  deliveryTerm: 'не позднее 3 рабочих дней',
  purgeTerm: '30 календарных дней',
  responseTerm: '10 календарных дней',
  /**
   * How long the destruction record is kept. Published here and enforced by
   * `DESTRUCTION_RECORD_RETENTION_YEARS` in the worker — two places, one number, exactly like
   * `purgeTerm` and `PURGE_QUARANTINE_DAYS`. Changing one without the other turns the policy
   * into a statement about a period nothing keeps.
   */
  destructionRecordTerm: 'три года',
  /** См. `destructionRecordTerm`: срок задаётся `PURGE_QUARANTINE_DAYS`. */
  quarantineTerm: 'семь дней',
  /**
   * Reports of abuse. The public book page is the same shared page as the North American
   * deployment uses — one mechanism, one address each (docs/abuse-response.md §5).
   */
  abuse: {
    email: 'abuse@mylore.ru',
  },
} as const;
